import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';
import firebase from 'firebase/app';

export function fetchDiscussion(response) {
  return {
    type: types.DISCUSSION_DROPDOWN,
    response
  };
}
export function discussionClassPlayer(response) {
  return {
    type: types.CLASS_PLAYER,
    response
  };
}
async function onVideoAnalytics(video) {
  await firebase.analytics().logEvent('add-on_class_video_event', {
    SubjectName: video.SubjectName,
    ClassTitle: video.ClassTitle,
    date_visited: new Date()
  });
}
export const fetchDiscussionData = async (jwtToken, dispatch) => {
  const body = {};
  const url = 'api/discussion/student/list';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      dispatch(fetchDiscussion(data));
    });
};

export const fetchClassData = async (
  uniqueCode,
  moduleCode,
  jwtToken,
  dispatch
) => {
  const body = {
    UniqueCode: uniqueCode
  };
  if (moduleCode) {
    body.ModuleCode = moduleCode;
  }
  const url = 'api/discussion/student/player';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      onVideoAnalytics(data.data);
      dispatch(discussionClassPlayer(data));
    });
};
